const SET_FETCHING = 'directOrder/SET_FETCHING';
const SET_SUBMITTING = 'directOrder/SET_SUBMITTING';

export default {
  SET_FETCHING,
  SET_SUBMITTING,
};
